export const getButtonCta = (t, _clientProgramStatus, accessLevel, alreadyProgram) => {
    switch (accessLevel) {
        case 'free':
            if (alreadyProgram) {
                return {
                    buttonCta: t('grant_single|resumeApplication'),
                    variant: 'main-action',
                };
            }
            return {
                buttonCta: t('grants|startApplicationCta'),
                variant: undefined,
            };
        case 'custom':
            if (!alreadyProgram) {
                return {
                    buttonCta: t('grants|sendApplicationToHelloDarwin'),
                    variant: undefined,
                };
            }
            return {
                buttonCta: t('grant_single|accessApplication'),
                variant: 'main-action',
            };
        case 'premium':
            if (alreadyProgram) {
                return {
                    buttonCta: t('grant_single|resumeApplication'),
                    variant: 'main-action',
                };
            }
            return {
                buttonCta: t('grants|startApplicationCta'),
                variant: undefined,
            };
        case 'expert':
            return {
                buttonCta: t('grantsFundingExplorer|grantsgrantCardLearnMore'),
                variant: 'navigation',
            };
        default:
            return {
                buttonCta: t('grant_single|applyNow'),
                variant: undefined,
            };
    }
};
